import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import "./AuthPage.css";
import { OrbitProgress } from "react-loading-indicators";
import { devInfoSelector } from "../../store/selectors";

const AuthPage = () => {
  const { login } = useAuth();
  const { isDev, devToken } = useSelector(devInfoSelector);

  // Redirect if already authenticated
  useEffect(() => {
    let token = localStorage.getItem("access_token");
    if (isDev) {
      token = devToken;
    }
    if (token) {
      login(token);
      return;
    }

    window.location.href = `https://go.7cut.video/api/v1/auth/login`;
  }, []);

  return (
    <div className="App">
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <OrbitProgress color="#C1C7D4" />
      </div>
    </div>
  );
};

export default AuthPage;
